import config from 'styles/config'
import { titleFont, titleFontSemiBold, textSize } from '@portal/kit/pkg/styles'

const mseButtonStyles = {
  loginMse: {
    display: 'flex',
      width: '100%',
        justifyContent: 'space-between',
          alignItems: 'center',
            marginBottom: 13,
    },
  loginMseTitle: {
      ...textSize(14, 18),
      ...titleFont(),

      '& strong': {
      display: 'block',
        ...titleFontSemiBold(),
      }
  },
  [config.mediaQueries.tabletPortrait]: {
    loginMseTitle: {
      ...textSize(16, 19),
    }
  }
}

export default mseButtonStyles
